module.exports = __webpack_public_path__ + "static/carousel-5-b883eb350661aa83e2b78ff8bc7ed9ee.png";